import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import {
  PRINT_BORDER,
  PRINT_COLOR_ADJUST,
  PRINT_LABEL_BG,
  mutedLabelTypographySx,
} from '../printStyles';
import { summaryCellSx } from './styles';

interface LabelCellProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const LabelCell = ({ children, sx = [] }: LabelCellProps) => (
  <Box
    sx={[
      {
        ...summaryCellSx,
        ...PRINT_COLOR_ADJUST,
        bgcolor: PRINT_LABEL_BG,
        borderRight: PRINT_BORDER,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <Typography sx={mutedLabelTypographySx}>{children}</Typography>
  </Box>
);

export default LabelCell;
